<script setup>
const route = useRoute()
const { data: cityConfig } = await useFetch('/api/wind/cityCode', { query: { citycode: route.params.city } })
if (!cityConfig.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid Path'
  })
}
useCustomMeta('city', cityConfig.value.name, '沖縄県')
const breadCrumbList = getBreadCrumb('okinawa', cityConfig.value.name)
const { data: mapPosition } = await useFetch('/api/wind/mapConfig', { query: { path: route.params.city } })
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
      :pref="getAreaPrefectureName('okinawa')"
      pref-roma="okinawa"
    >
      <div class="frame">
        <WindMap
          :map-position="mapPosition"
          :title="cityConfig.name"
          pref-en="okinawa"
          :city-code="route.params.city"
        />
      </div>
      <template #main-bottom>
        <WindCityList pref="okinawa" />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.ads-btf1-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
